var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import RequestQuoteOutlinedIcon from "@mui/icons-material/RequestQuoteOutlined";
import { Alert, Avatar, Box, Button, Checkbox, Stack, Typography, } from "@mui/material";
import { Modal } from "../../components/Modal";
import { useAuth } from "../../hooks/useAuth";
import { obterBoleto } from "../../services/veiculos.service";
import { Colors } from "../../util/theme";
import { FormButton, FormButtonType } from "../FormButton";
import { SnackbarFeedback } from "../SnackbarFeedback";
import { ViewPdf } from "../ViewPdf";
export var CardTaxaCondutor = function (_a) {
    var debito = _a.debito, onChangeCheckbox = _a.onChangeCheckbox;
    var userInfo = useAuth().userInfo;
    var _b = useState(false), modalBoleto = _b[0], setModalBoleto = _b[1];
    var _c = useState(), erro = _c[0], setErro = _c[1];
    var _d = useState(false), loading = _d[0], setLoading = _d[1];
    var _e = useState(undefined), base64 = _e[0], setBase64 = _e[1];
    var _f = useState(false), isChecked = _f[0], setIsChecked = _f[1];
    var verificarData = function (data) {
        var _a = data.split("/"), dia = _a[0], mes = _a[1], anoHora = _a[2];
        var _b = anoHora.split(" "), ano = _b[0], _c = _b[1], hora = _c === void 0 ? "00:00:00" : _c;
        // Validação para formato DD/MM/YYYY ou DD/MM/YYYY HH:mm:ss
        if (!/^\d{2}\/\d{2}\/\d{4}( \d{2}:\d{2}(:\d{2})?)?$/.test(data)) {
            throw new Error("Data em formato inválido. Use DD/MM/YYYY ou DD/MM/YYYY HH:mm:ss");
        }
        // Criação do objeto de data
        var dataComparacao = new (Date.bind.apply(Date, __spreadArray([void 0, Number(ano),
            Number(mes) - 1,
            Number(dia)], hora.split(":").map(Number), false)))();
        var dataAtual = new Date();
        // Retorno baseado na comparação
        return dataComparacao < dataAtual ? "Em Atraso" : "Pendente";
    };
    var gerarBoleto = function () { return __awaiter(void 0, void 0, void 0, function () {
        var payload, response, error_1;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    setLoading(true);
                    setErro(undefined);
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, 4, 5]);
                    payload = {
                        cpf: userInfo === null || userInfo === void 0 ? void 0 : userInfo.preferred_username,
                        listaIdDebito: debito.idDebito.toString(),
                    };
                    return [4 /*yield*/, obterBoleto(payload)];
                case 2:
                    response = _d.sent();
                    setBase64(response.pdf);
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _d.sent();
                    setErro((_c = (_b = (_a = error_1 === null || error_1 === void 0 ? void 0 : error_1.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.MensagemRetorno) !== null && _c !== void 0 ? _c : "Erro ao gerar boleto");
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    setModalBoleto(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(Stack, __assign({ boxShadow: "1", borderRadius: "0.25rem", mb: "1rem", sx: { backgroundColor: "white" } }, { children: [_jsxs(Stack, __assign({ flexDirection: "row", justifyContent: "space-between", padding: "0.75rem" }, { children: [_jsx(Stack, __assign({ flexDirection: "row", alignItems: "start", gap: "1rem" }, { children: _jsxs(Box, { children: [_jsx(Typography, __assign({ variant: "body1", fontSize: "1.125rem", fontWeight: "500" }, { children: debito.descricaoReduzida })), _jsxs(Typography, __assign({ variant: "body2", color: "textSecondary", fontSize: "1rem" }, { children: ["Exerc\u00EDcio: ", debito.exercicio] })), _jsxs(Typography, __assign({ variant: "body2", color: "textSecondary", fontSize: "1rem" }, { children: ["Vencimento: ", debito.dataVencimento] })), _jsxs(Typography, __assign({ variant: "body1", fontSize: "1rem" }, { children: ["Valor:", " ", parseFloat(debito.valorVencimento.replace(",", ".")).toFixed(2)] }))] }) })), _jsxs(Stack, __assign({ direction: { md: "row", sm: "column-reverse" }, alignItems: { md: "start", sm: "end" }, width: "20%" }, { children: [_jsx(Button, __assign({ onClick: function () { return setModalBoleto(true); }, variant: "outlined", sx: {
                                    height: "50%",
                                    border: "1px solid ".concat(Colors.AZUL_GOV),
                                    color: Colors.AZUL_GOV,
                                }, fullWidth: true }, { children: "Emitir" })), _jsx(Checkbox, { checked: isChecked, onChange: function (event) {
                                    setIsChecked(event.target.checked);
                                    onChangeCheckbox(debito.idDebito);
                                } })] }))] })), _jsxs(Alert, __assign({ severity: verificarData(debito.dataVencimento) === "Em Atraso"
                    ? "error"
                    : "warning", sx: {
                    alignItems: "center",
                } }, { children: ["Situa\u00E7\u00E3o: ", verificarData(debito.dataVencimento)] })), _jsx(Modal, { open: modalBoleto, onClose: function () { return setModalBoleto(false); }, icon: _jsx(Avatar, __assign({ sx: {
                        bgcolor: Colors.AZUL_GOV,
                        width: "3.25rem",
                        height: "3.25rem",
                        alignSelf: "center",
                    } }, { children: _jsx(RequestQuoteOutlinedIcon, { fontSize: "large" }) })), title: "Emiss\u00E3o de Boleto para Pagamento", subTitle: "Voc\u00EA deseja emitir o Boleto Banc\u00E1rio para pagamento da Taxa?", buttons: [
                    _jsx(FormButton, { isDisabled: loading, title: "CONFIRMAR", type: FormButtonType.PRIMARY, onClick: gerarBoleto, isLoading: loading }, 0),
                    _jsx(FormButton, { title: "VOLTAR", type: FormButtonType.SECONDARY, onClick: function () { return setModalBoleto(false); } }, 1),
                ], directionButtons: "row-reverse" }), base64 && (_jsx(ViewPdf, { isOpen: !!base64, close: function () { return setBase64(undefined); }, base64: base64, title: debito.descricaoReduzida })), erro && _jsx(SnackbarFeedback, { isOpen: !!erro, message: erro, type: "error" })] })));
};
